<template>
  <div id="Statistics">

    <Head />
    <div class="hotspot clear">
      <Nav ms="/Announcement" />
      <div v-if="tabChange == 0" class="H-right">
        <!-- <span style="margin-left:1rem;font-size:0.18rem;font-weight:800;background:url('../../assets/back/txt.png') left center no-repeat;">通知公告</span> -->
        <div class="title">通知公告管理</div>
        <div class="H-header">
          <div class="t-right">
            <div class="btn btnmini" @click="tabClick('1', '1')">新增</div>
          </div>
          <div class="t-left">
            <select name id v-model="Type" @change="getNew">
              <option value="1,2,3,4,5,6">全部</option>
              <option :value="item.code" v-for="(item, index) in options" :key="index">{{ item.codename }}</option>
            </select>
            <!-- <div
              class="btn btnmini"
              style="width:1rem;margin-left: 0.2rem;border-radius:0.04rem;"
              @click="getinfo('1')"
            >查询</div>-->
            <!-- <el-upload
              ref="uploads"
              id="upload1"
              style="opacity:0"
              class="avatar-uploader"
              :http-request="upload"
              :auto-upload="false"
              action="upload1"
              :on-success="handleSuccess"
              :on-change="submitUpload"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>-->
          </div>
        </div>
        <div class="t_main">
          <el-table border :header-cell-style="{ 'background-color': '#001743', 'color': '#fff', 'height': '0.5rem' }" :stripe="true" :data="tableData1" style="width: 100%;max-height:95%" :row-style="{ 'height': '0.4rem' }">
            <el-table-column label="序号" header-align="center" align="center" width="80">
              <template slot-scope="scope">
                <p>{{ scope.row.index }}</p>
                <i v-if="scope.row.TopNo > 0" class="zd"></i>
              </template>
            </el-table-column>
            <el-table-column prop="ID" label="类型" header-align="center" align="center" width="80">
              <template slot-scope="scope">
                <div>{{ goType(scope.row.Type) }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="Title" label="动态标题" header-align="center" align="center"></el-table-column>
            <!-- <el-table-column prop="Details" label="内容" header-align="center" align="center">
              <template slot-scope="scope">
                <div>{{SetWord(scope.row.Details)}}</div>
              </template>
            </el-table-column>-->
            <el-table-column prop="Date" label="时间" header-align="center" align="center" width="120"></el-table-column>
            <el-table-column label="操作" header-align="center" align="center" :width="wid">
              <template slot-scope="scope">
                <div class="btns">
                  <el-button size="mini" style="background: #2D65D2;color:#ffffff;" @click="tabClick('1', 3, scope.row.ID)">修改</el-button>
                  <el-button size="mini" style="background: #F3252F;color:#ffffff;" @click="Del(scope.row)">删除</el-button>
                  <el-button size="mini" type="danger" style="background:#f76423" @click="top(scope.row)">{{ scope.row.TopNo > 0 ? "取消" : "置顶" }}</el-button>
                </div>
                <el-dropdown>
                  <el-button type="primary" style="padding:0 5px;height:30px">
                    选择操作
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      <template>
                        <span @click="tabClick('1', 3, scope.row.ID)">修改</span>
                      </template>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <template>
                        <span @click="Del(scope.row)">删除</span>
                      </template>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <template>
                        <span @click="top(scope.row)">{{ scope.row.TopNo > 0 ? "取消" : "置顶" }}</span>
                      </template>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination style="text-align: right;height: 0.45rem;" v-if="tableData1.length > 0" @current-change="CurrentChange1" @size-change="handleSizeChange1" :current-page="Page1" :page-size="PageSize1" :page-sizes="[10, 20, 30]" layout="total,sizes, prev, pager, next, jumper" :total="total1"></el-pagination>
        </div>
        <!-- <div class="Popup" v-show="isPopup">
          <div class="none" @click="Popups(0)"></div>
          <div v-if="isPopup" class="a_forms">
            <div class="f-top">
              <div @click='Popups(0)'></div>
              {{tabType==1?'修改':'新增'}}通知
            </div>
            <div class="f-info">
              <div class="p-info">
                <div class="p-input">
                  <span>类别：</span>
                  <select v-model="infoForm.Type">
                    <option :value="item.code" v-for="(item,index) in options" :key="index">{{item.codename}}</option>
                  </select>
                  <i>*</i>
                </div>
                <div class="p-input">
                  <span>标题：</span>
                  <input type="text" v-model="infoForm.Title">
                  <i>*</i>
                </div>
                <div class="p-input">
                  <span>图片：</span>
                  <div>
                    <img v-if="infoForm.imageUrl" :src="infoForm.imageUrl" >
                    <div v-else @click="uploadImg" class="btn">上传</div>
                  </div>
                  <i>*</i>
                </div>
                <div class="p-input">
                  <span>代码：</span>
                  <input type="text" v-model="infoForm.FileCode">
                  <i></i>
                </div>
                <div class="p-input">
                  <span>时间：</span>
                  <div class="p-time">
                    <input type="text" v-model="infoForm.Date">
                    <el-date-picker
                      @change='dataChange'
                      class="p-select"
                      v-model="infoForm.Date"
                      type="date"
                      placeholder="选择日期">
                    </el-date-picker>
                    <div class="icon"></div>
                  </div>
                  <i>*</i>
                </div>
                <div>
                  <span>内容：</span>
                  <div class="quill">
                    <quill-editor 
                      ref="myQuillEditor"
                      class="editor"
                      v-model="infoForm.Details"                       
                      @blur="onEditorBlur($event)" 
                      @focus="onEditorFocus($event)" 
                      @change="onEditorChange($event)">
                    </quill-editor>
                  </div>
                  <i>*</i>
                </div>
                <div class="p-input">
                  <span>状态：</span>
                  <select v-model="infoForm.Status">
                    <option value="0" >发布</option>
                    <option value="1">下架</option>
                  </select>
                  <i>*</i>
                </div>
              </div>
              <div class="f-bottom">
                <div class="btn" v-if='tabType==0' @click="addinfo">提交</div>
                <div class="btn" v-else @click="setInfo">提交</div>
              </div>
            </div>
          </div>
        </div>-->
      </div>
      <div v-if="tabChange == 1" class="H-right">
        <div class="btn btnmini" style="margin-bottom: 0.2rem;" @click="tabClick(0, 1)">返回</div>
        <div class="f-info">
          <div class="p-info">
            <div class="p-input">
              <span>类别：</span>
              <select v-model="infoForm.Type">
                <option :value="item.code" v-for="(item, index) in options" :key="index">{{ item.codename }}</option>
              </select>
              <i>*</i>
            </div>
            <div class="p-input">
              <span>标题：</span>
              <input type="text" v-model="infoForm.Title" @change="change" />
              <i>*</i>
            </div>

            <div class="p-input">
              <span>来源：</span>
              <input type="text" v-model="infoForm.Source" @change="change" />
              <i>*</i>
            </div>
            <div class="p-input">
              <span>图片：</span>
              <div>
                <div @click="uploadImg" class="btn btnmini" style="width:1rem;">上传</div>
                <img v-if="infoForm.Image" :src="infoForm.Image" class="avatar" style="width:2rem;" />
              </div>
              <i></i>
            </div>
            <!-- <div class="p-input">
              <span>代码：</span>
              <input type="text" v-model="infoForm.FileCode" />
              <i></i>
            </div>-->
            <div class="p-input">
              <span>时间：</span>
              <div class="p-time">
                <input type="text" v-model="infoForm.Date" />
                <el-date-picker @change="dataChange" class="p-select" v-model="infoForm.Date" type="date" placeholder="选择日期"></el-date-picker>
                <div class="icon"></div>
              </div>
              <i>*</i>
            </div>
            <div>
              <span>内容：</span>
              <!-- <div class="quill">
                <quill-editor
                  ref="myQuillEditor"
                  class="editor"
                  v-model="infoForm.Details"
                  @blur="onEditorBlur($event)"
                  @focus="onEditorFocus($event)"
                  @change="onEditorChange($event)"
                ></quill-editor>
              </div>-->
              <div class="quill">
                <wangEditor v-model="infoForm.Details" @change="change" />
              </div>
              <i>*</i>
            </div>
            <div>
              <!-- :action="$URL + 'upload/newsdoc?token=' + token" -->
              <span>附件：</span>
              <div class="fj">
                <el-upload class="upload-demo" action="/" :http-request="uploadFile" :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove" :on-progress="progress" :on-error="error" multiple :data="{ 'upload_type': 'files' }" :limit="6" :headers="{ 'enctype': 'multipart/form-data' }" :on-exceed="handleExceed" :on-success="success1" :file-list="fileList" accept=".doc, .docx, .xls, .xlsx, .pdf">
                  <template>
                    <div class="anniu">
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" class="el-upload__tip">只能上传doc/docx/xls/xlsx/pdf,最多上传6个附件</div>
                    </div>

                  </template>
                </el-upload>
                <!-- <div v-if="fileList.length>0">
                  <div v-for="(item,index) in fileList" :key="index">
                    {{item.name}}
                  </div>
                </div> -->

                <!-- <ul>
                  <li>
                    <a href="javascript:;">{{infoForm.DocLink1.split("/")[infoForm.DocLink1.split("/").length-1]}}</a>
                  </li>
                  <li>
                    <a href="javascript:;">{{infoForm.DocLink2.split("/")[infoForm.DocLink2.split("/").length-1]}}</a>
                  </li>
                  <li>
                    <a href="javascript:;">{{infoForm.DocLink3.split("/")[infoForm.DocLink3.split("/").length-1]}}</a>
                  </li>
                  <li>
                    <a href="javascript:;">{{infoForm.DocLink4.split("/")[infoForm.DocLink4.split("/").length-1]}}</a>
                  </li>
                  <li>
                    <a href="javascript:;">{{infoForm.DocLink5.split("/")[infoForm.DocLink5.split("/").length-1]}}</a>
                  </li>
                  <li>
                    <a href="javascript:;">{{infoForm.DocLink6.split("/")[infoForm.DocLink6.split("/").length-1]}}</a>
                  </li>
                </ul> -->
              </div>
            </div>
            <div class="p-input">
              <span>状态：</span>
              <select v-model="infoForm.Status">
                <option value="0">发布</option>
                <option value="1">下架</option>
              </select>
              <i>*</i>
            </div>
          </div>
          <div class="f-bottom">
            <!-- <div class="btn" v-if="tabType==0" @click="addinfo">提交</div> -->
            <div class="btn" @click="tijiao">提交</div>
            <!-- <div class="btn" v-else @click="setInfo">提交</div> -->
            <div class="btn" style="width:2rem;" @click="tabClick(2)">预览</div>
          </div>
        </div>
      </div>
      <div v-if="tabChange == 2" class="H-right">
        <div class="btn btnmini" style="margin-bottom: 0.2rem;" @click="tabClick(1, 2)">返回</div>
        <div class="hMain">
          <p>{{ infoForm.Title }}</p>
          <p>
            发布时间： {{ infoForm.Date }}
            <span></span>
            来源：{{ infoForm.Source }}
          </p>
          <div class="ql-editor" v-html="infoForm.Details"></div>
          <div class="fj" v-if="fileList.length > 0">
            <p>附件:</p>
            <ul>
              <li v-for="(item, i) in fileList" :key="i">{{ item.name }}</li>
              <!-- <li>
                <a
                  href="javascript:;"
                >{{that}}</a>
              </li>
              <li>
                <a
                  href="javascript:;"
                >{{infoForm.DocLink2.split("/")[infoForm.DocLink2.split("/").length-1]}}</a>
              </li>
              <li>
                <a
                  href="javascript:;"
                >{{infoForm.DocLink3.split("/")[infoForm.DocLink3.split("/").length-1]}}</a>
              </li>
              <li>
                <a
                  href="javascript:;"
                >{{infoForm.DocLink4.split("/")[infoForm.DocLink4.split("/").length-1]}}</a>
              </li>
              <li>
                <a
                  href="javascript:;"
                >{{infoForm.DocLink5.split("/")[infoForm.DocLink5.split("/").length-1]}}</a>
              </li>
              <li>
                <a
                  href="javascript:;"
                >{{infoForm.DocLink6.split("/")[infoForm.DocLink6.split("/").length-1]}}</a>
              </li>-->
            </ul>
          </div>
          <div>
            <p>网站声明：凡本网转载自其它媒体的各类新闻，转载目的在于传递更多信息，并不代表本网赞同</p>
            <p>其观点和对其真实性负责。</p>
          </div>
        </div>
      </div>
    </div>
    <el-upload ref="uploads" id="upload1" style="opacity:0;height:0;overflow:hidden;" class="avatar-uploader1" :http-request="upload" :auto-upload="false" action="upload1" :on-success="handleSuccess" :on-change="submitUpload" :show-file-list="false" :before-upload="beforeAvatarUpload">
      <i class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
    <Foot />
  </div>
</template>
<script>
import Head from "../../components/BackHead";
import Foot from "../../components/Foot";
import Nav from "../../components/BackNav";
import wangEditor from "../../components/wangEnduit/wangEnduit";
export default {
  name: "Announcement",
  data() {
    return {
      index: "",
      token: "",
      tabType: "",
      tabChange: 0,
      total1: 0,
      tableData1: [],
      Page1: 1,
      value1: 1,
      PageSize1: 10,
      isPopup: false,
      classForm: "",
      fileList: [],
      wid: "",
      Type: "1,2,3,4,5,6", // 查询条件
      detectStrArr: [
        "法轮功",
        "徐和柴学友",
        "修炼之歌",
        "警察殴打",
        "新诗年鉴",
        "李沛瑶遇害",
        "美国凯德",
        "肥东交警",
        "中央军委",
        "针对台湾",
        "梁保华",
        "M军团",
        "旧民运",
        "伪民运",
        "采花堂",
        "中国劳工通讯",
        "评中国共产党",
        "反雷达测速",
        "建立生活性补贴",
        "中共走狗",
        "中共小丑",
        "共奴",
        "中共恶霸",
        "共产无赖",
        "右派",
        "流氓政府",
        "原子弹制作简明教程",
        "盘古乐队",
        "绝食抗议",
        "北戴河会议",
        "邓二世",
        "内斗退党",
        "退团",
        "江理论",
        "香港六合彩",
        "集中营",
        "退党",
        "法新闻社",
        "欧洲圆明网",
        "亚太正悟网",
        "大法新闻社",
        "白宫事件",
        "亚太正悟网",
        "大法新闻社",
        "自宫事件",
        "且本大使馆R游行",
        "反且万人游行",
        "六四屠杀",
        "六四屠城",
        "六四政变",
        "军长砸洗浴中心",
        "中共邪教",
        "调查真相委员会",
        "追查国际",
        "中共暴行",
        "大法洪传",
        "弘法体",
        "大法之声",
        "江独裁",
        "李屠夫",
        "江恶人",
        "江戏子",
        "中共特务",
        "乙醚",
        "党内分裂",
        "新生网",
        "圆明网",
        "发正念",
        "放下生死",
        "大法大福",
        "大酷弟子",
        "大纪元",
        "支联会",
        "共产专制",
        "共产王朝",
        "大法洪传",
        "毛派",
        "法网恢恢",
        "邓派",
        "鹰派",
        "赣江学院暴动",
        "全国退党",
        "绝食抗基",
        "维权抗暴",
        "活体器官",
        "中共暴政",
        "器官移植.",
        "中共恶霸",
        "共产无赖",
        "中共当局",
        "胡温政府",
        "江罗集团",
        "师傅法身",
        "正派民运 .",
        "中华联邦政府",
        "亲共行动",
        "联邦政府",
        "流氓民运",
        "特务民运",
        "江贼民二",
        "中共警察",
        "中共蓝狱",
        "中共政权",
        "中共迫害",
        "自由联邦.",
        "中共独枭",
        "流氓无产者",
        "中共专制",
        "明慧周刊",
        "九评共产党",
        "江泽民其人",
        "色情",
        "秘密文件.",
        "政府文件",
        "自梦",
        "破网软件",
        "美少妇哀羞",
        "阿兵哥言语录",
        "遥想当年春衫薄.",
        "王子淫传",
        "神雕外传之郭襄",
        "睡着武神",
        "少年阿宾",
        "首先使用核武器",
        "汽车爆炸案",
        "香港GH水",
        "透视眼镜",
        "色空寺",
        "周容重",
        "朱蒙",
        "汕頭頻傳擄童割器官",
        "法輪功",
        "六决丕",
        "清华网管",
        "济南建设路",
        "老虎机",
        "轮盘机",
        "玫瑰园",
        "二卡多号",
        "最淫官员",
        "偷电",
        "盗电",
        "中国人都在上四大当",
        "总统讲话_",
        "痛批政法委",
        "山西黑砖窑",
        "黑窑妪役",
        "杨元元",
        "粱保华",
        "敢坐飞机吗",
        "夜勤病栋",
        "一本道",
        "夜欢",
        "夜情",
        "e情",
        "阴部",
        "淫电影",
        "阴阜",
        "阴户",
        "淫贱",
        "淫教师",
        "淫媚",
        "阴精",
        "淫声浪语",
        "淫术炼金士",
        "淫水",
        "淫照",
        "幼男",
        "幼女",
        "玉女心经",
        "玉蒲团",
        "欲仙欲死",
        "宝乳",
        "原味内衣",
        "援助交际",
        "中年美妇",
        "抓胸",
        "自拍",
        "自慰",
        "作爱",
        "片",
        "g片",
        "h动画",
        "h动漫",
        "inest",
        "sm女王",
      ], //敏感词汇数组
      minganci: false,
      minganci1: false,
      minganci2: false,
      infoForm: {
        Title: "",
        Details: "",
        Date: "",
        Type: "1",
        Status: 0,
        FileCode: "",
        Image: "",
        Source: "",
        DocLink1: "",
        DocLink2: "",
        DocLink3: "",
        DocLink4: "",
        DocLink5: "",
        DocLink6: "",
      },
      infoFormCop: {
        Title: "",
        Details: "",
        Date: "",
        Type: "1",
        Status: 0,
        FileCode: "",
        Image: "",
        Source: "",
        DocLink1: "",
        DocLink2: "",
        DocLink3: "",
        DocLink4: "",
        DocLink5: "",
        DocLink6: "",
      },
      redianForm: {
        Title: "",
        Details: "",
        Date: "",
        Type: "1",
        Status: 0,
        FileCode: "",
        Image: "",
        Source: "",
      }, //热点缓存
      options: [],
    };
  },
  created() {
    // sessionStorage.setItem("token",'company-70374788cd5a72fc3fb58c59f1c3fdc3')
    this.token = sessionStorage.getItem("token");
    this.getOptions();
    this.getinfo();
  },
  mounted() {
    if (window.outerWidth < 1540) this.wid = "100";
    else this.wid = "210";
  },
  inject: [""],
  methods: {
    tijiao() {
      "CreateDatetime" in this.infoForm ? this.setInfo() : this.addinfo();
    },
    top(info) {
      // console.log(info)
      if (info.TopNo > 0) {
        this.setTop("information/cancletop", info.ID);
      } else {
        this.setTop("information/settop", info.ID);
      }
    },
    setTop(url, id) {
      this.$axios
        .post(
          url,
          this.$qs.stringify({
            ID: id,
            token: sessionStorage.getItem("token"),
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            this.$message({ type: "success", message: "操作成功" });
            this.getinfo();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getNew: function () {
      this.getinfo("1");
    },
    toObj2(key, val) {
      var data = { [key]: val };
      return data;
    },
    success1(res, file, fileList) {
      if (res.code == 10000) {
        this.$message({ message: res.msg, type: "success" });
        this.fileList = fileList;
      } else {
        this.$message({ message: res.msg, type: "warning" });

        this.fileList = fileList.pop();
      }
      console.log(this.fileList);
      console.log(file);
      console.log(fileList);
    },
    error(err, file, fileList) {
      console.log(fileList);
      console.log(err);
      if (err) {
        this.$message({
          message: "上传失败",
          type: "warning",
        });
      }
      console.log(file);
    },
    progress(event, file, fileList) {
      console.log(event);

      console.log(file);
      console.log(fileList);
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    handlePreview() { },
    handleExceed() {
      this.$message.warning("当前限制最多上传 6 个文件");
    },
    beforeRemove(file, fileList) {
      console.log(fileList);
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    change() {
      let that = this;
      if (that.strDetect(that.infoForm.Title)) {
        //  that.$message("您提交的内容包含敏感词汇!");
        that.minganci = true;
      } else {
        that.minganci = false;
      }

      if (that.strDetect(that.infoForm.Source)) {
        //  that.$message("您提交的内容包含敏感词汇!");
        that.minganci1 = true;
      } else {
        that.minganci1 = false;
      }
      if (that.strDetect(that.infoForm.Details)) {
        // that.$message("您提交的内容包含敏感词汇!");
        that.minganci2 = true;
      } else {
        that.minganci2 = false;
      }
    },
    Popups(e, f) {
      if (e == 1) {
        if (f) {
          this.infoForm = f;
          this.tabType = 1;
        } else {
          this.tabType = 0;
          this.infoForm = Object.assign({}, this.redianForm);
        }
        this.isPopup = !this.isPopup;
      } else {
        this.redianForm = Object.assign({}, this.infoForm);
        this.isPopup = !this.isPopup;
      }
    },
    SetWord(v) {
      if (v != null) {
        var dd = v.replace(/<\/?.+?>/g, "");
        var dds = dd.replace(/ /g, ""); //dds为得到后的内容
        if (dds.length > 100) {
          dds = dds.substr(0, 100);
          dds += "...";
        }
        return dds;
      }
    },
    getfileList(name) {
      var DocLink = {};
      // console.log(name)
      if (name) {
        var names = name.split("/");
        DocLink.name = names[names.length - 1];
        DocLink.url = name;
      }
      console.log(DocLink, '111')
      return DocLink;
    },
    tabClick(e = 0, a, f) {
      console.log(e);
      let that = this;
      this.tabChange = e;
      // console.log(e);
      if (a == 1) {
        this.fileList = [];
      }
      if (e == 1) {
        if (f) {
          this.$axios
            .post(
              "information/info",
              this.$qs.stringify({
                ID: f,
                token: sessionStorage.getItem.token,
              })
            )
            .then((res) => {
              if (res.data.code == 10000) {
                this.infoForm = res.data.data;
                for (var key in this.infoForm) {
                  switch (key) {
                    case "DocLink1":
                      if (this.infoForm.DocLink1) {
                        var DocLink1 = Object.assign(
                          {},
                          that.getfileList(this.infoForm.DocLink1)
                        );
                        //  that.fileList.forEach(va=>{
                        //     if( val.url!=f.DocLink1){
                        that.fileList.push(DocLink1);
                        //     }
                        //  })

                        // var DocLink1 = that.toObj2("name",arr[arr.length-1])
                        //   DocLink1=
                      }
                      break;
                    case "DocLink2":
                      if (this.infoForm.DocLink2) {
                        var DocLink2 = Object.assign(
                          {},
                          that.getfileList(this.infoForm.DocLink2)
                        );
                        that.fileList.push(DocLink2);
                      }
                      break;
                    case "DocLink3":
                      if (this.infoForm.DocLink3) {
                        var DocLink3 = Object.assign(
                          {},
                          that.getfileList(this.infoForm.DocLink3)
                        );
                        that.fileList.push(DocLink3);
                      }
                      break;
                    case "DocLink4":
                      if (this.infoForm.DocLink4) {
                        var DocLink4 = Object.assign(
                          {},
                          that.getfileList(this.infoForm.DocLink4)
                        );
                        that.fileList.push(DocLink4);
                      }
                      break;
                    case "DocLink5":
                      if (this.infoForm.DocLink5) {
                        var DocLink5 = Object.assign(
                          {},
                          that.getfileList(this.infoForm.DocLink5)
                        );
                        that.fileList.push(DocLink5);
                      }
                      break;
                    case "DocLink6":
                      if (this.infoForm.DocLink6) {
                        var DocLink6 = Object.assign(
                          {},
                          that.getfileList(this.infoForm.DocLink6)
                        );
                        that.fileList.push(DocLink6);
                      }
                      break;
                  }
                }
                console.log(that.fileList);
              } else {
                this.$message.error(res.data.msg);
              }
            });
          this.infoForm = f;
        } else if (a == 1) {
          this.tabType = 0;
          this.fileList = [];
          // for (var key1 in this.infoForm) {
          //   this.infoForm[key1]=""
          // }
          this.infoForm = Object.assign({}, this.redianForm);
        }
      } else if (e == 0) {
        // this.tabType = 2;
        // this.redianForm= Object.assign({}, this.infoForm);
      }
    },
    CurrentChange1(val) {
      //console.log(val)
      this.Page1 = val;
      this.getinfo();
    },
    handleSizeChange1(val) {
      //console.log(val)
      this.PageSize1 = val;
      this.getinfo();
    },
    // 富文本框
    onEditorBlur(e) {
      console.log(e);
    },
    onEditorFocus(e) {
      //获得焦点事件
      console.log(e);
    },
    onEditorChange(e) {
      //内容改变事件
      console.log(e);
    },
    // handleSuccess(response, file, fileList) {
    //   console.log(response);
    //   console.log(file, fileList);
    // },
    submitUpload() {
      this.$refs.uploads.submit();
    },
    // 测试上传
    handleSuccess(response, file, fileList) {
      console.log(response);
      console.log(file, fileList);
    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === "image/jpeg" || "image/gif" || "image/png";
      // const isLt2M = file.size / 1024 / 1024 < 2;

      // if (!isJPG) {
      //   this.$message.error("上传图片只能是图片格式!");
      // }
      // if (!isLt2M) {
      //   this.$message.error("上传图片大小不能超过 2MB!");
      // }
      // return isJPG && isLt2M;
      console.log(file);
      return true;
    },
    Del(e) {
      var that = this;
      this.$confirm("确认删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.$axios
            .post(
              "information/del?token=" + sessionStorage.getItem("token"),
              that.$qs.stringify({ ID: e.ID })
            )
            .then((res) => {
              console.log(res);
              if (res.data.code == 10000) {
                that.$message({
                  message: "删除成功",
                  type: "success",
                });
                that.getinfo();
                // this.reload();
              } else {
                that.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    setInfo() {
      var that = this;
      console.log("修改");
      console.log(that.fileList);
      this.$confirm("确认修改吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          (that.infoForm.DocLink1 = ""),
            (that.infoForm.DocLink2 = ""),
            (that.infoForm.DocLink3 = ""),
            (that.infoForm.DocLink4 = ""),
            (that.infoForm.DocLink5 = ""),
            (that.infoForm.DocLink6 = ""),
            that.fileList.forEach((val, index) => {
              console.log(val, index);
              if (val.url) {
                that.infoForm = Object.assign(
                  that.infoForm,
                  that.toObj2("DocLink" + (index + 1), val.url)
                );
                // that.infoForm = Object.assign(
                //   that.infoForm,
                //   that.toObj2("DocLink" + (index + 2), "")
                // );
              } else {
                that.infoForm = Object.assign(
                  that.infoForm,
                  that.toObj2("DocLink" + (index + 1), val.response.data)
                );
                // that.infoForm = Object.assign(
                //   that.infoForm,
                //   that.toObj2("DocLink" + (index + 2), "")
                // );
              }
            });
          console.log(that.infoForm);
          that.$axios
            .post(
              "information/update?token=" + sessionStorage.getItem("token"),
              that.$qs.stringify(this.infoForm)
            )
            .then((res) => {
              console.log(res);
              if (res.data.code == 10000) {
                that.$message({
                  message: res.data.msg,
                  type: "success",
                });
                that.getinfo();
                this.tabClick(0);
                that.fileList = [];
              } else {
                that.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消修改",
          });
        });
    },
    goType(e) {
      for (var i = 0; i < this.options.length; i++) {
        if (this.options[i].code == e) {
          return this.options[i].codename;
        }
      }
    },
    getOptions() {
      var that = this;
      that.$axios
        .post(
          "parameter/info?token=" +
          sessionStorage.getItem("token") +
          "&tablename=information&fieldname=type"
        )
        .then((res) => {
          if (res.data.code == 10000) {
            console.log(res.data.data);
            this.options = res.data.data;
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        });
    },
    //敏感字符串检测方法
    strDetect(str) {
      var that = this;
      console.log(1111666);
      let a = false;
      console.log(str);
      that.detectStrArr.forEach(function (v) {
        if (str.indexOf(v) !== -1) {
          // str = str.replace(v, "***");
          console.log(str);
          a = true;
        }
      });
      // for(var i=0;i<that.detectStrArr.length;i++){
      //   if(str.indexOf(that.detectStrArr[i])!=-1){
      //     this.$alert('您提交的内容包含敏感词汇!', '温馨提示', {
      //     confirmButtonText: '确定',
      //     // callback: action => {
      //     //   this.$message({
      //     //     type: 'info',
      //     //     message: `action: ${ action }`
      //     //   });
      //     // }
      //   });
      return a;
      //   }
      // }
    },
    addinfo() {
      var that = this;
      // 提交之前做一次敏感词检测
      console.log(this.infoForm);
      if (that.minganci || that.minganci1 || that.minganci3) {
        that.$message({
          message: "输入信息带有敏感词",
          type: "warning",
        });
        return;
      }
      console.log(that.fileList)
      that.fileList.forEach((val, index) => {
        // console.log(val,index)
        if (val.url) {

          that.infoForm = Object.assign(
            that.infoForm,
            that.toObj2("DocLink" + (index + 1), val.url)
          );
        }
      });
      // console.log(that.infoForm)
      // that.infoForm.Title = that.strDetect(that.infoForm.Title);
      // that.infoForm.Source = that.strDetect(that.infoForm.Source);
      // that.infoForm.Details = that.strDetect(that.infoForm.Details);
      this.$confirm("确认提交该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        that.$axios
          .post(
            "information/add?token=" + sessionStorage.getItem("token"),
            that.$qs.stringify(this.infoForm)
          )
          .then((res) => {
            if (res.data.code == 10000) {
              console.log(res.data.data);
              that.fileList = [];
              for (var key in that.infoForm) {
                // console.log(that.infoForm[key])
                that.infoForm[key] = "";
              }
              // that.infoForm.type=1;
              // that.infoForm.Status=0;
              //提交成功后返回
              this.tabClick(0);
              that.$message({
                message: res.data.msg,
                type: "success",
              });
              that.getinfo();
              this.Popups(0);
            } else {
              this.$message({
                message: res.data.msg,
                type: "warning",
              });
            }
          });
      });
    },
    getinfo(a) {
      if (a == 1) {
        this.Page1 = 1;
      }
      var that = this;
      that.$axios
        .post(
          "information/index?token=" + sessionStorage.getItem("token"),
          that.$qs.stringify({
            Type: this.Type,
            page: this.Page1,
            num: this.PageSize1,
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            that.fileList = [];
            console.log(res.data.data);
            this.tableData1 = res.data.data.list;
            this.tableData1.forEach((val, index) => {
              val.index = index + 1;
            });
            console.log(this.tableData1);
            this.total1 = res.data.data.total_num;
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        });
    },
    uploadImg() {
      document.querySelector(".avatar-uploader1 input").click();
    },
    uploadFile(file) {
      let that = this;
      var formData = new FormData();
      console.log(file, file.file)
      formData.append("file", file.file);
      formData.append("upload_type", "files");
      that.$axios
        .post(
          "upload/newsdoc?token=" + sessionStorage.getItem("token"),
          formData,
          {
            headers: {
              "Content-type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          if (res.data.code == 10000) {
            this.fileList.push({ ...file.file, name: file.file.name, url: res.data.data })
            console.log(this.fileList)
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.$forceUpdate()
          }
        });
    },
    upload(file) {
      let that = this;
      console.log(file);
      var formData = new FormData();
      formData.append("file", file.file);
      formData.append("upload_type", "image");
      that.$axios
        .post(
          "upload/index?token=" + sessionStorage.getItem("token"),
          formData,
          {
            headers: {
              "Content-type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          console.log(res);
          if (res.data.code == 10000) {
            this.infoForm.Image = res.data.data;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          }
        });
      this.$refs.uploads.clearFiles();
    },
    dataChange(e) {
      console.log(e);
      var date = new Date(e);
      console.log(date.getFullYear(), date.getMonth(), date.getDate());
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      this.infoForm.Date = Y + M + D;
    },
  },
  components: {
    Head,
    Foot,
    Nav,
    wangEditor,
  },
};
</script>
<style lang="less" scoped>
.el-dropdown {
  display: none;
}

.btns {
  display: flex;
}

@media screen and (max-width: 1800px) {
  .el-dropdown {
    display: block;
  }

  .btns {
    display: none !important;
  }

  .el-table__row td:last-child {
    .cell {
      padding-left: 0px;

      .el-button {
        font-size: 12px;
      }
    }
  }

  .el-dropdown-menu {
    li {
      padding: 0;

      span {
        display: inline-block;
        padding: 0 20px;
        width: 100%;
        height: 100%;
      }
    }

    li:hover {
      color: #fff !important;
    }

    li:first-of-type:hover {
      background: #2d65d2;
    }

    li:nth-of-type(2):hover {
      background: #f3252f;
    }

    li:last-of-type:hover {
      background: #f76423;
    }
  }
}

.fj {
  width: 50%;

  .anniu {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-left: 0.2rem;
  }
}

.clear:after {
  /*伪元素是行内元素 正常浏览器清除浮动方法*/
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

select {
  font-size: 0.16rem;
  height: 0.5rem;
}

// .editor{
//   width: 100%;
//   height: 3rem;
// }
.btn {
  width: 4.6rem;
  cursor: pointer;
  height: 0.58rem;
  line-height: 0.58rem;
  font-size: 0.17rem;
  text-align: center;
  background: #2d65d2;
  color: #fff;
}

.btnchange {
  background-color: #ffffff;
  border: 1px #aaaaaa solid;
  color: #000000;
}

.btnmini {
  width: 1rem;
  height: 0.4rem;
  line-height: 0.4rem;
  border-radius: 0.05rem;
}

.hotspot {
  width: 100%;
  min-width: 1000px;
  font-size: 0.16rem;
  padding: 0.28rem 2.54rem;
  box-sizing: border-box;

  .H-right {
    position: relative;
    width: 11.5rem;
    padding-left: 0.2rem;
    height: 100%;
    float: right;
    min-height: 8rem;
    border-left: 1px #eeeeee solid;

    .title {
      font-size: 0.4rem;
      margin: 0.2rem 0 0.5rem;
      text-align: center;
    }

    .btnselect {
      display: flex;
    }

    .H-header {
      .t-left {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 0.5rem;

        > span,
        select,
        div,
        input {
          width: 2rem;
          height: 0.4rem;
          border-radius: 0;
        }

        input {
          padding: 0.05rem;
        }
      }

      .t-right {
        float: right;
      }
    }
  }
}

.Popup {
  width: 100%;
  position: absolute;
  top: 0;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;

  .none {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .a_forms {
    position: absolute;
    left: 50%;
    top: 0.5rem;
    transform: translate(-50%, 0);
    width: 10.11rem;
    height: 8rem;
    background: white;
    font-size: 0.16rem;

    .f-top {
      height: 0.5rem;
      width: 100%;
      text-align: center;
      line-height: 0.5rem;
      position: relative;
      border-bottom: 1px #cfcfcf solid;

      div {
        cursor: pointer;
        position: absolute;
        right: 0;
        top: 0;
        height: 0.5rem;
        width: 0.5rem;
        background: url("../../assets/back/x.png") center center no-repeat;
      }
    }
  }
}

.t_main {
  .zd {
    display: inline-block;
    width: 0.3rem;
    height: 0.3rem;
    background-image: url("../../assets/back/zd.png");
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 0;
    background-size: 100%;
  }
}

.f-info {
  padding: 0 0.54rem;

  .p-info {
    > .p-input {
      align-items: center;

      > div {
        position: relative;
        flex: 1;
        margin: 0 0.2rem;
      }
    }

    > .upimg {
      align-items: center;
      justify-content: space-between;
    }

    > div {
      margin: 0.2rem 0;
      display: flex;

      > .p-time {
        position: relative;
        flex: 1;
        margin: 0 0.2rem;

        > input {
          width: 100%;
          padding: 0.05rem;
          height: 0.4rem;
          border: 1px #cccccc solid;
        }

        .p-select {
          width: 100%;
          top: 0;
          left: 0;
          opacity: 0;
          position: absolute;
        }

        .icon {
          position: absolute;
          top: 0;
          right: 0;
          height: 0.4rem;
          width: 0.4rem;
          background: url("../../assets/back/time.png") center center no-repeat;
        }
      }

      > input,
      select {
        flex: 1;
        padding: 0.05rem;
        margin: 0 0.2rem;
        height: 0.4rem;
        border: 1px #cccccc solid;
      }

      > .quill {
        max-width: 89%;
        flex: 1;
        margin: 0 0.2rem;
      }

      i {
        font-style: normal;
        color: #ff0d0d;
        width: 0.2rem;
      }
    }
  }

  .f-bottom {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
}

.hMain {
  position: relative;
  border: 1px solid #ababab;
  margin: 0 auto;
  background: #fafdff;

  span {
    display: inline-block;
    width: 0.1rem;
  }

  > p {
    width: 97%;
    font-size: 0.22rem;
    margin: 0 auto;
    padding-bottom: 0.1rem;
    color: #4f4f4f;
    text-indent: 2em;
    margin-bottom: 0.1rem;
  }

  > p:nth-of-type(1) {
    text-align: center;
    font-size: 0.35rem;
    color: #333;
    border-bottom: 1px solid #ccc;
    padding-bottom: 0.3rem;
    font-weight: bold;
    margin: 0.3rem 0;
  }

  > p:nth-of-type(2) {
    height: 0.5rem;
    line-height: 0.5rem;
    background: #f4f9fd;
    text-align: center;
    font-size: 0.18rem;
    color: #666666;
    margin-top: 0.3rem;
    margin-bottom: 0.4rem;
  }

  div {
    width: 96%;
    border: 1px dashed #ddd;
    // background: #f0f6fb;
    margin: 0.6rem 0 0 0.2rem;
    padding: 0.1rem 0;
    font-size: 0.2rem;
    text-indent: 2em;

    p {
      line-height: 1.5;
    }

    p:nth-of-type(1) {
      margin-bottom: 0.1rem;
    }
  }

  .fj {
    p {
      margin: 0.3rem 0 0.2rem !important;
    }

    ul {
      padding-left: 0.6rem;
    }

    li {
      font-size: 0.16rem;
      text-decoration: underline;
      margin-bottom: 0.2rem;

      a.active {
        color: royalblue;
      }
    }
  }
}
</style>